import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ReactComponent as TermSignSuccess } from "assets/svg/term-sign-success.svg";
import { ReactComponent as SensiaFerramenta } from "assets/svg/sensia-ferramenta.svg";
import { Button } from "@company-mrv/mrv-design-system/components";
import { EditSquare } from "@company-mrv/mrv-design-system/icons";
import { getThemeName } from "utils/pluginHelpers";
import * as Styled from "./styles";

const MAINTENANCE_START_DATE = new Date("2026-05-19T00:00:00");
const MAINTENANCE_END_DATE = new Date("2026-05-27T23:59:59");
const STORAGE_KEY = "maintenance-modal-dismissed";

export const shouldShowMaintenanceModal = () => {
  const now = new Date();
  const isInPeriod =
    now >= MAINTENANCE_START_DATE && now <= MAINTENANCE_END_DATE;
  const alreadyDismissed = sessionStorage.getItem(STORAGE_KEY) === "true";
  return isInPeriod && !alreadyDismissed;
};

const getIllustration = () => {
  if (getThemeName() === "Sensia") {
    return <SensiaFerramenta width={40} height={40} />;
  }
  return <TermSignSuccess width={96} height={96} />;
};

const ModalMaintenance = ({ show, onRequestClose }) => {
  useEffect(() => {
    if (show) {
      sessionStorage.setItem(STORAGE_KEY, "true");
    }
  }, [show]);

  if (!show) return null;

  const handleUpdateData = () => {
    onRequestClose();
    window.location.href = `atendimento/perfil`;
  };

  return (
    <Styled.Modal isOpen={show} onRequestClose={onRequestClose}>
      <Styled.Content>
        <Styled.TextWrapper>
          <Styled.ImageWrapper isSensia={getThemeName() === "Sensia"}>
            {getIllustration()}
          </Styled.ImageWrapper>
          <Styled.Title>Programe-se</Styled.Title>
          <Styled.Description>
            Vamos atualizar nossos sistemas para otimizar a sua jornada!
            {"\n\n"}Entre <strong>28/05 e 08/06</strong>, o app do seu lar
            ficará indisponível.
            {"\n\n"}Para sua tranquilidade, enviaremos todos os boletos do
            período para o seu e-mail antes do dia 27/05.
            {"\n\n"}Verifique se seus dados estão atualizados para receber tudo
            em dia.
          </Styled.Description>
        </Styled.TextWrapper>
        <Styled.Actions>
          <Styled.ButtonEntendi
            color="primary"
            onClick={onRequestClose}
            theme={getThemeName()}
          >
            Entendi
          </Styled.ButtonEntendi>
          <Button
            liquid
            variant="ghost"
            color="primary"
            iconLeft={<EditSquare a11yTitle="" />}
            onClick={handleUpdateData}
            theme={getThemeName()}
          >
            Atualizar dados cadastrais
          </Button>
        </Styled.Actions>
      </Styled.Content>
    </Styled.Modal>
  );
};

ModalMaintenance.propTypes = {
  show: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired
};

export default ModalMaintenance;
